// extracted by mini-css-extract-plugin
export var adjacentSlide = "_nd-9";
export var arrowButtonContainer = "_nd-5";
export var arrowButtonIcon = "_nd-6";
export var carouselArrowButton = "_nd-2";
export var carouselElementContainer = "_nd-1";
export var currentSlide = "_nd-8";
export var left = "_nd-3";
export var otherSlide = "_nd-a";
export var productCarouselContainer = "_nd-0";
export var right = "_nd-4";
export var sliderOverflow = "_nd-7";